import { 
    userSettings
} from '@/globals/userSettings';

import adjustFontSize from "@/tools/adjustFontSize";
import renderTools from "./renderTools";
import renderFilter from './renderFilter';

export default function runAccessibility() {
    adjustFontSize(userSettings?.states?.fontSize);
    renderTools();
    renderFilter();
}